






import { Vue, Component } from 'vue-property-decorator';
import * as config from './config';
import { getrules } from './api';
import { appShare, wxShareInfo } from '@/common/ts/common';
@Component
export default class HomeIndexSelectRules extends Vue {
  option = config.OPTHINES;
  rules: string = '';
  created() {
    getrules(this.option.voteName).then((res: any) => this.rules = res.data);
    this.$addPv(372);
    appShare({
      title: '2019年重庆市志愿服务先进典型宣传',
      url: window.location.href,
      subtitle: '2019年重庆市志愿服务先进典型宣传',
      image: 'http://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
      classId: -1,
      id: -1,
      type: 3,
    });
    wxShareInfo({
      title: '2019年重庆市志愿服务先进典型宣传',
      subtitle: '2019年重庆市志愿服务先进典型宣传',
      image: 'http://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
    });
  }
}
